<template>
	<v-row justify="center">
		<v-dialog v-model="dialog" persistent max-width="900">
			<v-card>
				<v-card-title class="text-h6" v-if="propAdd=='tambah'">Tambah Supplier</v-card-title>
				<v-card-title class="text-h6" v-else>Edit Supplier</v-card-title>
				<v-card-text>
					<v-row>
						<v-col cols="12" sm="12" md="12">
							<v-row>
								<v-col cols="12" sm="6" md="4" class="pb-0">
									<v-text-field outlined dense @focus="() => konfirmResponse.name=''" :error-messages="konfirmResponse.name" v-model="paramAdd.name" label="Nama Supplier"></v-text-field>
								</v-col>
								<v-col cols="12" sm="6" md="4" class="pb-0">
									<v-text-field @keypress="onlyNumber" @paste.prevent  outlined dense @focus="() => konfirmResponse.mobilephone=''" :error-messages="konfirmResponse.mobilephone" v-model="paramAdd.mobilephone" label="No. Handphone"></v-text-field>
								</v-col>
								<v-col cols="12" sm="6" md="4" class="pb-0">
									<v-text-field outlined dense @focus="() => konfirmResponse.email=''" :error-messages="konfirmResponse.email" v-model="paramAdd.email" label="Email"></v-text-field>
								</v-col>
								<v-col cols="12" md="4" class="pb-0">
									<v-autocomplete outlined dense v-model="provinsi" @focus="() => konfirmResponse.province_id=''" :error-messages="konfirmResponse.province_id" :items="province" label="Provinsi" item-text="province" item-value="province_id" @change="getCity" no-data-text="Tidak ada data yang sesuai"></v-autocomplete>
								</v-col>
								<v-col cols="12" md="4" class="pb-0">
									<v-autocomplete outlined dense v-model="kota" @focus="() => konfirmResponse.city_id=''" :error-messages="konfirmResponse.city_id" :items="city" label="Kota/Kabupaten" @change="getSubdistrict" :item-text="item => item.type + ' ' + item.city_name" item-value="city_id" no-data-text="Tidak ada data yang sesuai"></v-autocomplete>
								</v-col>
								<v-col cols="12" md="4" class="pb-0">
									<v-autocomplete @change="cekMaps" outlined dense @focus="() => konfirmResponse.subdistrict_id=''" :error-messages="konfirmResponse.subdistrict_id" v-model="subdistrict_selected" :items="subdistrict" item-text="subdistrict_name" return-object label="Kecamatan" no-data-text="Tidak ada data yang sesuai"></v-autocomplete>
								</v-col>
								<v-col cols="12" md="4" class="pb-0">
									<v-textarea @change="cekMaps" outlined dense @focus="() => konfirmResponse.address=''" :error-messages="konfirmResponse.address" v-model="paramAdd.address" label="Alamat" no-resize height="170" hide-details="auto"></v-textarea>
								</v-col>
								<v-col cols="12" md="8" class="pb-0">
									<GmapMap :center="{ lat: location.lat, lng: location.lng}" :zoom="16" :options="mapOptions" map-type-id="roadmap" style="width: 100%; height: 100%" >
										<GmapMarker ref="myMarker" :position="{ lat: location.lat, lng: location.lng}" :draggable="true" @dragend="updateCoordinates" />
									</GmapMap>
								</v-col>
							</v-row>
						</v-col>
					</v-row>
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn color="grey darken-1" outlined @click="batal" class="text-capitalize">Batal</v-btn>
					<v-btn color="primary" depressed @click="simpan" class="text-capitalize">Simpan</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
		<v-snackbar v-model="snackbar" :timeout="timeout" right top :color="snackbarClass">
			{{ text }}
			<template v-slot:action="{ attrs }">
				<v-btn color="white" text v-bind="attrs" @click="snackbar = false">
					<v-icon>mdi-close</v-icon>
				</v-btn>
			</template>
		</v-snackbar>
	</v-row>
</template>

<script>
import {mapActions, mapState, mapMutations} from 'vuex'
export default {
	data () {
		return {
			page: 1,
			limit: "10",
			params: [],
			area_selected : '',
			provinsi : '',
			kota : '',
			subdistrict_selected : '',
			snackbarClass : "green accent-4",
			snackbar: false,
			text : "",
			timeout: 2000,
			paramAdd: {
				name: '',
				mobilephone: '',
				email: '',
				province_id : '',
				province_name : '',
				city_id : '',
				city_name : '',
				subdistrict_id : '',
				subdistrict_name : '',
				address : '',
				latitude : '',
				longitude : '',
			},
			mapOptions:{
				zoomControl: false,
				mapTypeControl: false,
				scaleControl: false,
				streetViewControl: false,
				rotateControl: false,
				fullscreenControl: false,
				disableDefaultUi: true
			},
		}
	},
	props: {
		value: Boolean,
		propAdd: String,
		edit: String,
		val: Object
	},
	computed: {
		...mapState('supplierList', ['konfirmResponse', 'responSukses', 'province', 'city', 'subdistrict']),
		...mapState('warehouseList', ['province', 'city', 'subdistrict']),
		...mapState('maps', ['location']),

		dialog: {
			get () {
				return this.value
			},
			set (value) {
				this.$emit('input', value)
			}
		}
	},
	methods: {
		...mapActions('warehouseList', ['getProvinceOption', 'getCityOption', 'getSubdistrictOption']),
		...mapActions('supplierList', ['getSupplier', 'addSupplier', 'updateSupplier']),
		...mapActions('maps', ['setLocation', 'getMaps']),
		...mapMutations('supplierList', ['konfirmasiSukses']),

		updateCoordinates(location){
			this.setLocation({
				lat: location.latLng.lat(),
				lng: location.latLng.lng()
			})
		},
		cekMaps(){
			this.getMaps((this.paramAdd.address ? this.paramAdd.address + ', ' : '') + this.subdistrict_selected.subdistrict_name + ', ' + this.subdistrict_selected.city_name + ', ' + this.subdistrict_selected.province)
		},
		getCity() {
			this.subdistrict_selected = '';
			this.kota = '';
			this.getCityOption(this.provinsi)
		},
		getSubdistrict() {
			this.subdistrict_selected = '';
			this.getSubdistrictOption(this.kota)
		},
		batal() {
			this.dialog = false
			this.konfirmResponse.name=''
			this.konfirmResponse.mobilephone=''
			this.konfirmResponse.email=''
			this.konfirmResponse.province_id=''
			this.konfirmResponse.province_name=''
			this.konfirmResponse.city_id=''
			this.konfirmResponse.city_name=''
			this.konfirmResponse.subdistrict_id=''
			this.konfirmResponse.subdistrict_name=''
			this.konfirmResponse.address=''
		},
		simpan() {
			this.paramAdd.latitude = this.location.lat
			this.paramAdd.longitude = this.location.lng
			this.paramAdd.province_id = this.provinsi
			this.paramAdd.province_name = this.subdistrict_selected.province
			this.paramAdd.city_id = this.kota
			this.paramAdd.city_name = this.subdistrict_selected.city_name
			this.paramAdd.subdistrict_id = this.subdistrict_selected.subdistrict_id
			this.paramAdd.subdistrict_name = this.subdistrict_selected.subdistrict_name
			if(this.paramAdd) {
				if(this.propAdd == 'tambah') {
					this.addSupplier(this.paramAdd).then( () => {
						if(this.responSukses.code == 200) {
							this.getSupplier({limit:this.limit, page: 1, params:this.params})
							this.dialog= false
							this.reset()
						}
					})
				} else {
					this.updateSupplier(this.paramAdd).then( () => {
						if(this.responSukses.code == 200) {
							this.getSupplier({limit:this.limit, page: 1, params:this.params})
							this.dialog = false
							this.reset()
						}
					})
				}
			}
		},
		reset () {
			this.konfirmasiSukses('')
			this.paramAdd.name = ''
			this.paramAdd.mobilephone = ''
			this.paramAdd.email = ''
			this.paramAdd.address = ''
			this.paramAdd.province_id = ''
			this.paramAdd.province_name = ''
			this.paramAdd.city_id = ''
			this.paramAdd.city_name = ''
			this.paramAdd.subdistrict_id = ''
			this.paramAdd.subdistrict_name = ''
			this.paramAdd.latitude = ''
			this.paramAdd.longitude = ''
			this.provinsi = ''
			this.kota = ''
			this.area_selected = ''
			this.subdistrict_selected = ''
			this.konfirmResponse.address=''
			this.konfirmResponse.area_id=''
			this.konfirmResponse.area_name=''
			this.konfirmResponse.city_id=''
			this.konfirmResponse.city_name=''
			this.konfirmResponse.mobilephone=''
			this.konfirmResponse.email=''
			this.konfirmResponse.name=''
			this.konfirmResponse.province_id=''
			this.konfirmResponse.province_name=''
			this.konfirmResponse.subdistrict_id=''
			this.konfirmResponse.subdistrict_name=''
		}
	},
	watch: {
		val () {
			this.paramAdd.id = this.val.supplier_id
			this.paramAdd.name = this.val.supplier_name
			this.paramAdd.email = this.val.supplier_email
			this.paramAdd.mobilephone = this.val.supplier_mobilephone
			this.provinsi = this.val.supplier_province_id
			if(this.provinsi) {
				this.getCityOption(this.provinsi)
			}
			this.kota = this.val.supplier_city_id
			if(this.kota) {
				this.getSubdistrictOption(this.kota)
			}
			this.subdistrict_selected = { "province_id": this.val.supplier_province_id, "province": this.val.supplier_province_name, "city_id": this.val.supplier_city_id, "city_name": this.val.supplier_city_name, "subdistrict_id": this.val.supplier_subdistrict_id, "subdistrict_name": this.val.supplier_subdistrict_name }
			this.paramAdd.address = this.val.supplier_address
			this.paramAdd.latitude = this.val.supplier_latitude
			this.paramAdd.longitude = this.val.supplier_longitude
		}
	},
	created() {
		this.getProvinceOption()
	}
}
</script>
